// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"1c9e40b8","212":"af2f473f","303":"a80ab842","396":"e0240847","421":"25b1d5ea","655":"493e975e"}[chunkId] + ".chunk.css";
};